// HiBFF B2C Dashboard - 10 Theme Definitions
// Each theme includes sidebar gradient, hero gradient, and accent colors

export const themes = {
  signature: {
    name: 'HiBFF Signature',
    cssVars: {
      // Sidebar Gradient (Light Gray → Dark Gray)
      '--sidebar-top': '#374151',
      '--sidebar-light': '#4B5563',
      '--sidebar-medium': '#6B7280',
      '--sidebar-slate': '#4B5563',
      '--sidebar-dark': '#374151',
      '--sidebar-bottom': '#1F2937',
      // Hero Gradient (Soft Pink → Light Cyan → Sky Blue)
      '--hero-start': '#FDF4F5',
      '--hero-middle': '#E0F2FE',
      '--hero-end': '#BAE6FD',
      // Accent Colors
      '--accent-primary': '#F59E0B',
      '--accent-secondary': '#3B82F6',
      '--accent-tertiary': '#EF4444',
      // Content
      '--content-bg': '#FFFFFF',
      '--card-bg': '#FFFFFF',
      '--card-border': '#E5E7EB',
      '--card-shadow': 'rgba(0, 0, 0, 0.05)',
      // Text
      '--text-primary': '#1F2937',
      '--text-secondary': '#6B7280',
      '--text-highlight': '#3B82F6',
      '--text-sidebar': '#FFFFFF',
      '--text-sidebar-active': '#F59E0B'
    }
  },
  ocean: {
    name: 'Ocean',
    cssVars: {
      '--sidebar-top': '#E0F2FE',
      '--sidebar-light': '#BAE6FD',
      '--sidebar-medium': '#7DD3FC',
      '--sidebar-slate': '#38BDF8',
      '--sidebar-dark': '#0EA5E9',
      '--sidebar-bottom': '#0369A1',
      '--hero-start': '#F0F9FF',
      '--hero-middle': '#E0F2FE',
      '--hero-end': '#BAE6FD',
      '--accent-primary': '#0EA5E9',
      '--accent-secondary': '#06B6D4',
      '--accent-tertiary': '#3B82F6',
      '--content-bg': '#FFFFFF',
      '--card-bg': '#F0F9FF',
      '--card-border': '#BAE6FD',
      '--card-shadow': 'rgba(14, 165, 233, 0.1)',
      '--text-primary': '#0C4A6E',
      '--text-secondary': '#075985',
      '--text-highlight': '#0EA5E9',
      '--text-sidebar': '#FFFFFF',
      '--text-sidebar-active': '#FFF'}
  },
  sunset: {
    name: 'Sunset',
    cssVars: {
      '--sidebar-top': '#FFF7ED',
      '--sidebar-light': '#FFEDD5',
      '--sidebar-medium': '#FED7AA',
      '--sidebar-slate': '#FB923C',
      '--sidebar-dark': '#F97316',
      '--sidebar-bottom': '#C2410C',
      '--hero-start': '#FFF7ED',
      '--hero-middle': '#FFEDD5',
      '--hero-end': '#FED7AA',
      '--accent-primary': '#F97316',
      '--accent-secondary': '#FB923C',
      '--accent-tertiary': '#EF4444',
      '--content-bg': '#FFFFFF',
      '--card-bg': '#FFFBEB',
      '--card-border': '#FED7AA',
      '--card-shadow': 'rgba(249, 115, 22, 0.1)',
      '--text-primary': '#7C2D12',
      '--text-secondary': '#9A3412',
      '--text-highlight': '#F97316',
      '--text-sidebar': '#FFFFFF',
      '--text-sidebar-active': '#FFF'
    }
  },
  lavender: {
    name: 'Lavender',
    cssVars: {
      '--sidebar-top': '#F5F3FF',
      '--sidebar-light': '#EDE9FE',
      '--sidebar-medium': '#DDD6FE',
      '--sidebar-slate': '#A78BFA',
      '--sidebar-dark': '#8B5CF6',
      '--sidebar-bottom': '#6D28D9',
      '--hero-start': '#FAF5FF',
      '--hero-middle': '#F3E8FF',
      '--hero-end': '#E9D5FF',
      '--accent-primary': '#8B5CF6',
      '--accent-secondary': '#A78BFA',
      '--accent-tertiary': '#C084FC',
      '--content-bg': '#FFFFFF',
      '--card-bg': '#FAF5FF',
      '--card-border': '#DDD6FE',
      '--card-shadow': 'rgba(139, 92, 246, 0.1)',
      '--text-primary': '#4C1D95',
      '--text-secondary': '#5B21B6',
      '--text-highlight': '#8B5CF6',
      '--text-sidebar': '#FFFFFF',
      '--text-sidebar-active': '#FFF'
    }
  },
  forest: {
    name: 'Forest',
    cssVars: {
      '--sidebar-top': '#F0FDF4',
      '--sidebar-light': '#DCFCE7',
      '--sidebar-medium': '#BBF7D0',
      '--sidebar-slate': '#4ADE80',
      '--sidebar-dark': '#22C55E',
      '--sidebar-bottom': '#15803D',
      '--hero-start': '#F0FDF4',
      '--hero-middle': '#DCFCE7',
      '--hero-end': '#BBF7D0',
      '--accent-primary': '#22C55E',
      '--accent-secondary': '#4ADE80',
      '--accent-tertiary': '#16A34A',
      '--content-bg': '#FFFFFF',
      '--card-bg': '#F0FDF4',
      '--card-border': '#BBF7D0',
      '--card-shadow': 'rgba(34, 197, 94, 0.1)',
      '--text-primary': '#14532D',
      '--text-secondary': '#166534',
      '--text-highlight': '#22C55E',
      '--text-sidebar': '#FFFFFF',
      '--text-sidebar-active': '#FFF'
    }
  },
  midnight: {
    name: 'Midnight (Dark Mode)',
    cssVars: {
      '--sidebar-top': '#1E293B',
      '--sidebar-light': '#334155',
      '--sidebar-medium': '#475569',
      '--sidebar-slate': '#64748B',
      '--sidebar-dark': '#334155',
      '--sidebar-bottom': '#0F172A',
      '--hero-start': '#1E293B',
      '--hero-middle': '#334155',
      '--hero-end': '#475569',
      '--accent-primary': '#60A5FA',
      '--accent-secondary': '#818CF8',
      '--accent-tertiary': '#F472B6',
      '--content-bg': '#0F172A',
      '--card-bg': '#1E293B',
      '--card-border': '#334155',
      '--card-shadow': 'rgba(0, 0, 0, 0.3)',
      '--text-primary': '#F1F5F9',
      '--text-secondary': '#CBD5E1',
      '--text-highlight': '#60A5FA',
      '--text-sidebar': '#E2E8F0',
      '--text-sidebar-active': '#60A5FA'
    }
  },
  memorial: {
    name: 'Memorial',
    cssVars: {
      '--sidebar-top': '#FAF5FF',
      '--sidebar-light': '#F3E8FF',
      '--sidebar-medium': '#E9D5FF',
      '--sidebar-slate': '#A78BFA',
      '--sidebar-dark': '#7C3AED',
      '--sidebar-bottom': '#5B21B6',
      '--hero-start': '#FAF5FF',
      '--hero-middle': '#F3E8FF',
      '--hero-end': '#E9D5FF',
      '--accent-primary': '#7C3AED',
      '--accent-secondary': '#A78BFA',
      '--accent-tertiary': '#C084FC',
      '--content-bg': '#FFFFFF',
      '--card-bg': '#FAFAFA',
      '--card-border': '#E9D5FF',
      '--card-shadow': 'rgba(124, 58, 237, 0.1)',
      '--text-primary': '#3F3F46',
      '--text-secondary': '#71717A',
      '--text-highlight': '#7C3AED',
      '--text-sidebar': '#FFFFFF',
      '--text-sidebar-active': '#FFF'
    }
  },
  sunrise: {
    name: 'Sunrise',
    cssVars: {
      '--sidebar-top': '#FEF3C7',
      '--sidebar-light': '#FDE68A',
      '--sidebar-medium': '#FCD34D',
      '--sidebar-slate': '#FBBF24',
      '--sidebar-dark': '#F59E0B',
      '--sidebar-bottom': '#D97706',
      '--hero-start': '#FFFBEB',
      '--hero-middle': '#FEF3C7',
      '--hero-end': '#FDE68A',
      '--accent-primary': '#F59E0B',
      '--accent-secondary': '#FBBF24',
      '--accent-tertiary': '#F97316',
      '--content-bg': '#FFFFFF',
      '--card-bg': '#FFFBEB',
      '--card-border': '#FDE68A',
      '--card-shadow': 'rgba(245, 158, 11, 0.1)',
      '--text-primary': '#78350F',
      '--text-secondary': '#92400E',
      '--text-highlight': '#F59E0B',
      '--text-sidebar': '#FFFFFF',
      '--text-sidebar-active': '#FFF'
    }
  },
  minimal: {
    name: 'Minimal (Grayscale)',
    cssVars: {
      '--sidebar-top': '#FAFAFA',
      '--sidebar-light': '#F4F4F5',
      '--sidebar-medium': '#D4D4D8',
      '--sidebar-slate': '#A1A1AA',
      '--sidebar-dark': '#71717A',
      '--sidebar-bottom': '#3F3F46',
      '--hero-start': '#FFFFFF',
      '--hero-middle': '#FAFAFA',
      '--hero-end': '#F4F4F5',
      '--accent-primary': '#18181B',
      '--accent-secondary': '#52525B',
      '--accent-tertiary': '#71717A',
      '--content-bg': '#FFFFFF',
      '--card-bg': '#FAFAFA',
      '--card-border': '#E4E4E7',
      '--card-shadow': 'rgba(0, 0, 0, 0.05)',
      '--text-primary': '#18181B',
      '--text-secondary': '#52525B',
      '--text-highlight': '#18181B',
      '--text-sidebar': '#FFFFFF',
      '--text-sidebar-active': '#18181B'
    }
  },
  neon: {
    name: 'Neon (Gen Z)',
    cssVars: {
      '--sidebar-top': '#ECFDF5',
      '--sidebar-light': '#D1FAE5',
      '--sidebar-medium': '#6EE7B7',
      '--sidebar-slate': '#10B981',
      '--sidebar-dark': '#059669',
      '--sidebar-bottom': '#047857',
      '--hero-start': '#FEF3C7',
      '--hero-middle': '#D1FAE5',
      '--hero-end': '#E0E7FF',
      '--accent-primary': '#EC4899',
      '--accent-secondary': '#8B5CF6',
      '--accent-tertiary': '#10B981',
      '--content-bg': '#FFFFFF',
      '--card-bg': '#FAFAFA',
      '--card-border': '#D1FAE5',
      '--card-shadow': 'rgba(236, 72, 153, 0.15)',
      '--text-primary': '#1F2937',
      '--text-secondary': '#4B5563',
      '--text-highlight': '#EC4899',
      '--text-sidebar': '#FFFFFF',
      '--text-sidebar-active': '#FFF'
    }
  }
};

// Apply theme function — sets CSS vars + Tailwind 'dark' class on <html> root so the
// dark: prefix cascades through every component, not just elements that explicitly
// reference --bg / --text vars (S-019).
export const applyTheme = (themeName) => {
  const theme = themes[themeName];
  if (!theme) return;

  const root = document.documentElement;
  Object.entries(theme.cssVars).forEach(([key, value]) => {
    root.style.setProperty(key, value);
  });

  // Cascade: any theme whose name suggests dark (or whose --bg lightness is low)
  // toggles the global Tailwind 'dark' class on <html>.
  const darkThemes = new Set(['ocean', 'midnight', 'forest', 'galaxy']);
  const isDark = darkThemes.has(themeName);
  if (isDark) {
    root.classList.add('dark');
  } else {
    root.classList.remove('dark');
  }

  // Save to localStorage
  localStorage.setItem('hibff-theme', themeName);
};

// Get current theme
export const getCurrentTheme = () => {
  return localStorage.getItem('hibff-theme') || 'signature';
};

// Initialize theme on app load
export const initializeTheme = () => {
  const savedTheme = getCurrentTheme();
  applyTheme(savedTheme);
};
